import { createContext } from 'react';

const VersionContext = createContext(null);

export default VersionContext;
